import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CrntIcon } from '@essent/current-web-angular';

import { OfferSaverContent } from '../../offer-saver.model';
import { EmailOfferModalComponent } from '../email-offer-modal/email-offer-modal.component';

@Component({
  selector: 'wl-offer-saver-button',
  standalone: true,
  templateUrl: 'offer-saver-button.component.html',
  imports: [CommonModule, CrntIcon],
})
export class OfferSaverButtonComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) content!: OfferSaverContent;

  brand = inject(ENVIRONMENT_CONFIG).brand;
  modalService = inject(NgbModal);

  get buttonClass(): string {
    return 'btn-link';
  }

  openEmailOfferModal(): void {
    const emailOfferModal = this.modalService.open(EmailOfferModalComponent);
    emailOfferModal.componentInstance.offerSaverModalContent =
      this.content.modals;
  }
}
